import React, { memo, useRef, useState, useEffect } from "react";
import { Tooltip } from "primereact/tooltip";

let cellInputCounter = 0;

const CellInput = ({ value, style = {}, tooltipStyle, tooltipPosition = "top" }) => {
  const textRef = useRef(null);
  const [isTruncated, setIsTruncated] = useState(false);
  const [copied, setCopied] = useState(false);
  const [tooltipId] = useState(() => `cell-input-${cellInputCounter++}`);

  useEffect(() => {
    const el = textRef.current;
    if (el) {
      setIsTruncated(el.scrollWidth > el.clientWidth);
    }
  }, [value]);

  if (!value || value.length === 0) return null;

  const handleClick = () => {
    navigator.clipboard.writeText(value);
    setCopied(true);
    setTimeout(() => setCopied(false), 1500);
  };

  return (
    <>
      <span
        ref={textRef}
        className={tooltipId}
        onClick={handleClick}
        style={{
          display: "block",
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
          maxWidth: "100%",
          cursor: "pointer",
          ...style,
        }}
      >
        {value}
      </span>
      <Tooltip
        target={`.${tooltipId}`}
        content={copied ? "Copied!" : value}
        position={tooltipPosition}
        style={tooltipStyle}
      />
    </>
  );
};

export const CellTextarea = ({ value, style = {}, tooltipStyle, tooltipPosition = "top" }) => {
  const textRef = useRef(null);
  const [isTruncated, setIsTruncated] = useState(false);
  const [copied, setCopied] = useState(false);
  const [tooltipId] = useState(() => `cell-textarea-${cellInputCounter++}`);

  useEffect(() => {
    const el = textRef.current;
    if (el) {
      setIsTruncated(el.scrollWidth > el.clientWidth);
    }
  }, [value]);

  if (!value || value.length === 0) return null;

  const handleClick = () => {
    navigator.clipboard.writeText(value);
    setCopied(true);
    setTimeout(() => setCopied(false), 1500);
  };

  return (
    <>
      <span
        ref={textRef}
        className={tooltipId}
        onClick={handleClick}
        style={{
          display: "block",
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
          maxWidth: "100%",
          cursor: "pointer",
          ...style,
        }}
      >
        {value}
      </span>
      <Tooltip
        target={`.${tooltipId}`}
        content={copied ? "Copied!" : value}
        position={tooltipPosition}
        style={tooltipStyle}
      />
    </>
  );
};

export default memo(CellInput);
